// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodePowerLoadProfilesAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodePowerLoadProfilesAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis',
)({
  component: EnergyTreeNodePowerLoadProfilesAnalysisPage,
});
